<nav class="navbar fixed-top navbar-light text-white bg-dark px-5">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">Presby Global Connect</a>
    <div class="p-2 bg-light text-dark rounded-pill">Isaac Kusi</div>
 
  </div>
</nav>
